module.exports = __webpack_public_path__ + "img/icon13.ac0c78cc.png";